import { render } from "./CommentForm.vue?vue&type=template&id=d5b1111c"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__